"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const reducers_1 = require("../../reducers");
const getCampaignType_1 = require("../../views/utils/getCampaignType");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const luxon_1 = require("luxon");
const getDateTimeFromDateTimeComponents_1 = require("../utils/getDateTimeFromDateTimeComponents");
const ListItemProgress = ({ campaign, media, totalProgress }) => {
    const { trigger } = campaign;
    let lifecycleStatus = '';
    let dateString = '';
    let timeZone = null;
    let timeZoneBadge;
    if (getCampaignType_1.isScheduledCampaignTrigger(trigger)) {
        if (trigger.dateTime !== null) {
            const { dateTime } = trigger;
            const scheduledAt = getDateTimeFromDateTimeComponents_1.default(dateTime, 'UTC+12');
            const now = luxon_1.DateTime.utc().setZone(scheduledAt.zone);
            lifecycleStatus = now < scheduledAt ? 'SCHEDULED' : 'SENT';
            dateString = scheduledAt.toFormat(`MMMM d, yyyy 'at' t`);
            timeZone = dateTime.timeZone;
        }
    }
    else if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
        const { filters } = trigger.eventTrigger;
        const filter = filters.find((el) => {
            return el.__typename === 'ScheduledEventTriggerFilter';
        });
        if (filter && filter.startDateTime !== null) {
            const { startDateTime, endDateTime } = filter;
            const start = getDateTimeFromDateTimeComponents_1.default(startDateTime, 'UTC+12');
            const now = luxon_1.DateTime.local();
            if (now < start) {
                lifecycleStatus = 'UPCOMING';
                dateString = start.toFormat('MMMM d, yyyy');
                timeZone = startDateTime.timeZone;
            }
            else if (endDateTime) {
                const end = getDateTimeFromDateTimeComponents_1.default(endDateTime, 'UTC-12');
                timeZone = endDateTime.timeZone;
                if (now > end) {
                    lifecycleStatus = 'EXPIRED';
                    dateString = end.toFormat('MMMM d, yyyy');
                }
                else {
                    lifecycleStatus = 'ACTIVE';
                    dateString = end.toFormat('MMMM d, yyyy');
                }
            }
            else {
                lifecycleStatus = 'ACTIVE';
            }
        }
    }
    if (campaign.status === 'DRAFT') {
        return (React.createElement("div", { style: {
                height: 24,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
            } },
            React.createElement(src_1.ProgressBar, { progress: totalProgress, style: {
                    progressStyle: {
                        backgroundColor: src_1.turquoise,
                    },
                    barStyle: {
                        width: media === 'Mobile' ? 156 : 256,
                    },
                    containerStyle: {
                        marginRight: 16,
                    },
                } }),
            media !== 'Mobile' && React.createElement(src_1.Text, { size: "small", text: `${totalProgress}% complete` })));
    }
    if (campaign.trigger.__typename === 'CampaignAPITrigger') {
        return React.createElement(React.Fragment, null);
    }
    let badgeColor;
    if (lifecycleStatus === 'ACTIVE' || lifecycleStatus === 'SENT') {
        badgeColor = src_1.green;
    }
    else if (lifecycleStatus === 'SCHEDULED') {
        badgeColor = src_1.yellow;
    }
    else {
        badgeColor = src_1.red;
    }
    if (timeZone) {
        timeZoneBadge = React.createElement(src_1.Badge, { color: src_1.charcoal, style: { marginLeft: 8 }, text: timeZone });
    }
    else if (dateString !== '') {
        timeZoneBadge = (React.createElement(src_1.GlobeIcon, { fill: src_1.charcoal, height: "12", style: { marginLeft: 8 }, viewBox: "0 0 24 24", width: "12" }));
    }
    const getLifecycleStatusText = () => {
        switch (lifecycleStatus) {
            case 'ACTIVE':
                return dateString ? `Until ${dateString}` : '';
            case 'EXPIRED':
                return dateString;
            case 'SCHEDULED':
            case 'SENT':
                return dateString;
            case 'UPCOMING':
                return `After ${dateString}`;
            default:
                return '';
        }
    };
    return (React.createElement("div", { style: {
            display: 'flex',
            alignItems: 'baseline',
        } },
        React.createElement(src_1.Badge, { color: badgeColor, text: lifecycleStatus, style: { marginRight: 8 } }),
        React.createElement(src_1.Text, { label: true, size: "small", text: getLifecycleStatusText(), textStyle: {
                color: src_1.steel,
            } }),
        media !== 'Mobile' && timeZone !== 'UTC' ? timeZoneBadge : null));
};
const mapStateToProps = (state, ownProps) => {
    const { campaign } = ownProps;
    return {
        totalProgress: reducers_1.getCampaignTotalProgress(state, campaign.id),
    };
};
exports.default = React.memo(react_redux_1.connect(mapStateToProps, {})(React.memo(ListItemProgress)));
